// extracted by mini-css-extract-plugin
module.exports = {"base":"Link_base__kH76H","fullWidth":"Link_fullWidth__BAp3H","preventUserSelection":"Link_preventUserSelection__IxK23"};